import React, { Component } from 'react';
import { connect } from 'react-redux';
import Orders from './orders';
import TableHeader from '../../../helper/tableHeader';
import {take} from 'ramda';
class OrderBook extends Component {
  constructor(){
    super()
    this.state = {view: 'open'}
  }
  changeView(view){
    this.setState({view})
  }
  render() {
    let titleStyle = {marginTop:'10px', marginLeft:'2px',color:'white'}
    let items = this.props.view == 'open' ? ['Send','Receive','Collateral','Order Lifespan','Settlement'] : ['Send','Receive','Collateral','Status']

    let first = {
      text : `Open Orders (${this.props.orders.length})`,
      action: this.changeView.bind(this,'open'),
    }

    let second = {
      text : `Unmatched Orders (${this.props.unmatched.length})`,
      action: this.changeView.bind(this,'closed')
    }

    if(this.props.view == 'closed'){
      let temp = second;
      second = first;
      first = temp;
    }


    // <span style={{cursor:'pointer',paddingLeft:'10px',color:'white',opacity:0.5,float:'right'}} onClick={second.action}>
    // {second.text}
    // </span>
    return (
      <div className='col s6' style={{paddingRight:'0.375rem'}}>
          <h6 style={titleStyle} >
            <span style={{cursor:'pointer',paddingRight:'10px',color:'white'}} onClick={first.action}>
            {first.text}
            </span>
          </h6>
        <div className='col s12 section'>
          <TableHeader items={items}/>
          <div className="col s12" style={{height:'200px',overflow:'scroll'}}>
            {this.props.view === 'open' ? <Orders orders={take(24,this.props.orders)}/> : <Orders orders={take(24,this.props.unmatched)} unlock={true}/>}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state,props) {
  return {
    orders : state.orderbook.my_orders,
    unmatched: state.orderbook.my_unmatched_orders
  };
}

export default connect(mapStateToProps,{})(OrderBook);
